import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { 
  AdminLoginAction,
  AdminLogoutAction,
  AdminRegisterAction,
  AdminForgotPasswordAction,
  AdminResetPasswordAction,
} from "../../Actions/adminActions";
import { updateAdminAuth } from "../../Reducers/Admin/adminAuthReducer";
import { 
  adminLogin,
  adminLogout,
  adminRegister,
  adminForgotPassword,
  adminResetPassword
} from "../../../services/adminAuthService";
import { apiResponse } from "../../../helper/helper";
import { toast } from "react-toastify";
import { toastConfiguration } from "../../../Constant/Data";

// Admin Login Saga
function* adminLoginSaga(action) {
  try {
    // yield put(updateAdminAuth({ loading: true, loadingType: "login" }));
    
    const response = yield call(adminLogin, action.payload);
    console.log("adminLogin---------",response)
    const {data,originalError}=response||{}
    if (response.ok) {
      if(data?.user?.role==="admin"){
        yield put(updateAdminAuth({
          adminToken: response?.data?.token,
          adminData: response?.data?.user,
        isAdminLoggedIn: true,
          loginSuccess: true,
          role: "admin",
        }));
      }
 else{     
toast.error("You don’t have permission to access the admin portal",toastConfiguration)
    }
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
  }
}

// Admin Logout Saga
function* adminLogoutSaga(action) {
  try {
    yield put(updateAdminAuth({ loading: true, loadingType: "logout" }));
    
    yield call(adminLogout);
    
    yield put(updateAdminAuth({
      adminToken: null,
      adminData: {},
      isAdminLoggedIn: false,
      logoutSuccess: true,
      loading: false,
      permissions: [],
      role: null,
    }));
  } catch (error) {
    yield put(updateAdminAuth({
      isError: true,
      errorMessage: error.message || "Logout failed",
      loading: false,
    }));
  }
}

// Admin Register Saga
function* adminRegisterSaga(action) {
  try {
    yield put(updateAdminAuth({ loading: true, loadingType: "register" }));
    
    const response = yield call(adminRegister, action.payload);
    
    if (response.success) {
      yield put(updateAdminAuth({
        registerSuccess: true,
        loading: false,
      }));
    } else {
      yield put(updateAdminAuth({
        isError: true,
        errorMessage: response.message || "Registration failed",
        loading: false,
      }));
    }
  } catch (error) {
    yield put(updateAdminAuth({
      isError: true,
      errorMessage: error.message || "Registration failed",
      loading: false,
    }));
  }
}

// Admin Forgot Password Saga
function* adminForgotPasswordSaga(action) {
  try {
    yield put(updateAdminAuth({ loading: true, loadingType: "forgotPassword" }));
    
    const response = yield call(adminForgotPassword, action.payload);
    
    if (response.success) {
      yield put(updateAdminAuth({
        forgotPasswordSuccess: true,
        loading: false,
      }));
    } else {
      yield put(updateAdminAuth({
        isError: true,
        errorMessage: response.message || "Forgot password failed",
        loading: false,
      }));
    }
  } catch (error) {
    yield put(updateAdminAuth({
      isError: true,
      errorMessage: error.message || "Forgot password failed",
      loading: false,
    }));
  }
}

// Admin Reset Password Saga
function* adminResetPasswordSaga(action) {
  try {
    yield put(updateAdminAuth({ loading: true, loadingType: "resetPassword" }));
    
    const response = yield call(adminResetPassword, action.payload);
    
    if (response.success) {
      yield put(updateAdminAuth({
        resetPasswordSuccess: true,
        loading: false,
      }));
    } else {
      yield put(updateAdminAuth({
        isError: true,
        errorMessage: response.message || "Reset password failed",
        loading: false,
      }));
    }
  } catch (error) {
    yield put(updateAdminAuth({
      isError: true,
      errorMessage: error.message || "Reset password failed",
      loading: false,
    }));
  }
}

// Watcher Sagas
export function* watchAdminLogin() {
  yield takeLatest(AdminLoginAction, adminLoginSaga);
}

export function* watchAdminLogout() {
  yield takeLatest(AdminLogoutAction, adminLogoutSaga);
}

export function* watchAdminRegister() {
  yield takeLatest(AdminRegisterAction.type, adminRegisterSaga);
}

export function* watchAdminForgotPassword() {
  yield takeLatest(AdminForgotPasswordAction.type, adminForgotPasswordSaga);
}

export function* watchAdminResetPassword() {
  yield takeLatest(AdminResetPasswordAction.type, adminResetPasswordSaga);
}
